<div style="background-color: #F5F7F8; height: 100vh; padding-top: 40px; display: grid;display: grid;">
    <div style="overflow-y: scroll; overflow-x: hidden;">
        <div class="row">
            <div class="col-2">
                <img  style="width: 22px; height: 22px; position: relative; top: 20px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">

            </div>
            <div class="col-10">
                <img  src="/assets/images/shared/logo.png" style="width: 90px; position: relative; right: 30px; height: 55px; display: block; margin: auto;" alt="">
            </div>
        </div>
        <h1 style="font-weight: bold;">Промени парола</h1>
        <form [formGroup]="this.resetPasswordsInfo">
            <div style="display: -webkit-box; width: 90%; margin: auto;">
                <input style="width: 100%;" matInput [type]="hide ? 'text': 'password'" class="form-control"  formControlName="currentPassword" [placeholder]="this.pageDetails().currentPassword"  aria-label="Username" aria-describedby="basic-addon1">
                <i style="position: relative; top: 10px; right: 40px;" class="material-icons" matSuffix (click) = "hide = !hide">{{hide ? 'visibility':'visibility_off'}}</i>
            </div>
            <div style="display: -webkit-box; width: 90%; margin: auto;">
                <input [autoClose]="'outside'" [ngbPopover]="popContent" (input)="this.checkPassoword($event.target)" style="width: 100%;" matInput [type]="hide ? 'text': 'password'" class="form-control" formControlName="newPassword" [placeholder]="this.pageDetails().newPassword"  aria-label="Username" aria-describedby="basic-addon1">
                <i style="position: relative; top: 10px; right: 40px;" class="material-icons" matSuffix (click) = "hide = !hide">{{hide ? 'visibility':'visibility_off'}}</i>
            </div>
            <div style="display: -webkit-box; width: 90%; margin: auto;">
                <input style="width: 100%;" matInput [type]="hide ? 'text': 'password'" class="form-control" formControlName="confirmPassword" [placeholder]="this.pageDetails().confirmPassword"  aria-label="Username" aria-describedby="basic-addon1">
                <i style="position: relative; top: 10px; right: 40px;" class="material-icons" matSuffix (click) = "hide = !hide">{{hide ? 'visibility':'visibility_off'}}</i>
            </div>
            <div class="alert alert-danger" *ngIf="this.error" role="alert"> {{ this.error }}</div>
        </form>
    </div>
    <div style="align-self: end; text-align: center; width: 90%; margin: auto;">
        <a style="width: 100vw; text-align: center; color: #0A69EB;" (click)="this.forgottenPassword()">{{ this.pageDetails().forgottenPassword }}</a>
        <button type="button" class="btn btn-primary" style="width: 100%; margin: auto; margin-top: 20px;" (click)="this.change()"> {{ this.pageDetails().button }} </button>
    </div>
</div>

<ng-template #popContent>
    <p>
        <span style="font-weight: bold; text-align: left;">Паролата трябва да съдържа</span>
        <br>
        <span [style]="this.isLengthCheckValid ? 'color: green;' : 'color: red;'">поне 8 символа</span>
        <br>
        <span [style]="this.isSmallLettersCheckValid ? 'color: green;' : 'color: red;'">малка буква</span>
        <br>
        <span [style]="this.isCapitalLettersCheckValid ? 'color: green;' : 'color: red;'">главна буква</span>
        <br>
        <span [style]="this.isDigitsCheckValid ? 'color: green;' : 'color: red;'">число</span>
        <br>
        <span [style]="this.isSymbolCheckValid ? 'color: green;' : 'color: red;'">символ</span>
    </p>
</ng-template>